// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".material-design-icon__svg[data-v-06439d55]{cursor:pointer}.tag span[data-v-06439d55]{color:#7a7a7a!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
